import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import ContentPage from "@/pages/ContentPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/content" element={<ContentPage />} />
      </Routes>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#0C1322",
            border: "1px solid rgba(255,255,255,0.1)",
            color: "#F8FAFC",
          },
        }}
      />
    </BrowserRouter>
  );
}

export default App;
